export default __webpack_public_path__ + "static/media/element_spec_33.218bd6cd.webp";